const BaseUrl = "http://162.62.121.176/";
// const BaseUrl = "http://127.0.0.1:9919/";

const InstructionTypeRefreshCondition = "100001";
const InstructionTypeRestartApp = "100002";
const InstructionTypeExitApp = "100003";
const InstructionTypeExecScript = "200001";
const InstructionTypeStopScript = "200002";
const InstructionTypePushScript = "200003";
const InstructionTypeDebugScript = "300001";

const ddYkralgoiouqwer = "gr$%*)+^75("

export default{
    BaseUrl, 
    InstructionTypeRefreshCondition, 
    InstructionTypeRestartApp, 
    InstructionTypeExitApp, 
    InstructionTypeExecScript, 
    InstructionTypeStopScript, 
    InstructionTypePushScript, 
    InstructionTypeDebugScript,
    ddYkralgoiouqwer
}


// WEBPACK FOOTER //
// ./src/assets/js/constants.js